{
  "Login": "Anmeldung",
  "Local Login": "Lokale Anmeldung",
  "email": "E-Mail",
  "password": "Passwort"
}
